import { useUnit } from 'effector-react'
import { MoneyHistoryRequest, MoneyHistoryType } from './types'
import {
  $moneyHistories,
  $totalCountOfMoneyHistories,
  moneyHistoriesListMounted,
  getMoneyHistories,
  $errorMoneyHistoriesRequest,
} from './model'


export const useMoneyHistoriesList = () => {
  const loading = useUnit(getMoneyHistories.pending)
  const onChangeMoneyHistoriesList = useUnit(moneyHistoriesListMounted)
  const moneyHistories = useUnit($moneyHistories)
  const totalCountOfMoneyHistories = useUnit($totalCountOfMoneyHistories)
  const errorMoneyHistoriesRequest = useUnit($errorMoneyHistoriesRequest)

  return {
    moneyHistories,
    totalCountOfMoneyHistories,
    loading,
    onChangeMoneyHistoriesList,
    errorMoneyHistoriesRequest,
  }
}
